<template>
    <div class="question-list ">
        <div class="Q-content">
            <endTime :endtime="endTime" />
            <div class="commit-content">
                <img src="../assets/images/icon.png" alt="">
                <p>您已提交{{questionnaireText}}模块问题,感谢您的参与！</p>
                <el-button class="toFirstPageBtn" @click="toHomePage">返回首页</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import EndTime from '../components/time.vue'
export default {
    name: 'CommitPage',
    components: {
        EndTime,
    },
    data() {
        return {
            endTime: '',
            questionnaireText:''
        }
    },

    created() {
        this.endTime = this.$route.query.endTime
        this.questionnaireText = this.$route.query.questionnaireText

    },
    mounted() {
        // this.endDate = this.$route.query.endDate
        console.log(this.endTime);

    },
    methods:{
        toHomePage(){
            this.$router.push({
                name:'QuestionList'
            })
        }
    }



}
</script>

<style lang="scss" scoped>
.question-list {
    .Q-content {
        background-color: #fff;
        width: 1000px;
        height: 780px;
        margin: 20px auto 60px;

        .commit-content {
            text-align: center;
            margin-top: 167px;
            p{
                margin: 20px 0;
            }
            .toFirstPageBtn {
                width: 280px;
                height: 48px;
                background: #FFFFFF;
                border: 1px solid #3B9395;
                border-radius: 2px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #3B9395;
            }
        }
    }

}
</style>